<div class="container">
  <form [formGroup]="form" (ngSubmit)="formSubmit.next()">
    <h1>Create Your Password</h1>

    <div
      class="password-requirements"
      [class.text-error]="passwordCtrl.invalid && passwordCtrl.touched"
    >
      <strong>Password requirements</strong>
      <mat-icon
        matTooltipPosition="above"
        matTooltip="Must contain at least 10 characters, at least one lowercase letter, at least one
          uppercase letter, at least one number, and at least one non-alphanumeric character"
        >info</mat-icon
      >
    </div>

    <mat-form-field>
      <mat-label>Password</mat-label>
      <input
        matInput
        [formControl]="form.controls.password"
        [type]="hidePassword ? 'password' : 'text'"
      />
      <mat-icon
        matSuffix
        color="primary"
        (click)="hidePassword = !hidePassword"
        >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
      >
    </mat-form-field>

    <mat-form-field>
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        [formControl]="form.controls.confirmPassword"
        [type]="hidePassword ? 'password' : 'text'"
      />
      <mat-icon
        matSuffix
        color="primary"
        (click)="hidePassword = !hidePassword"
        >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
      >
    </mat-form-field>

    <button mat-flat-button color="primary" [disabled]="!form.valid">
      Register
    </button>

    @if (
      confirmPasswordCtrl.invalid &&
      confirmPasswordCtrl.touched &&
      confirmPasswordCtrl.errors?.matching
    ) {
      <span class="error">Passwords do not match.</span>
    }
  </form>

  @if (formSubmitResponse$ | async; as response) {
    @if (!response.success) {
      <span class="error">{{ response.message }}</span>
    }
  }
</div>
